import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoTagLarge]',
  host: { class: 'xpo-tag xpo-tag--large' },
})
export class XpoLargeTag {}
